<template>
	<div>
		<div class="form-group">
			<button type="button" class="btn btn-success" v-on:click.prevent="openModal()" v-if="encuestas.length>0">
				<i class="material-icons">note_add</i> Agregar Pregunta
			</button>
		</div>
		<preloader v-if="loadingData"></preloader>
		<ul class="list-group" v-if="encuestas.length>0">
			<li class="list-group-item list-encuesta-focus" v-for="encuesta in encuestas">
				<div class="d-flex w-100 justify-content-between">
					<h5 class="mb-1">
						<i class="fas fa-question fa-2x fa-pull-left fa-border"></i>
						{{encuesta.CODIGO_PREGUNTA}} - {{encuesta.PREGUNTA}}
					</h5>
					<div class="btn-group" role="group" aria-label="Opciones">
	    				<a href="#" v-on:click.prevent="editModal(encuesta)" v-tooltip="'Editar'" class="btn btn-link">
	    					<i class="material-icons">edit</i>
	    				</a>
	    				<a href="#" v-on:click.prevent="deleteModal(encuesta)" v-tooltip="'Eliminar'" class="btn btn-link">
	    					<i class="material-icons">delete</i>
	    				</a>
    				</div>
    			</div>
			</li>
		</ul>
		
		<div v-if="encuestas.length== 0 && loadingData == false">
			<empty icon="playlist_add" title="Agrega la primer pregunta" description="Para poder visualizar el listado de las preguntas debes agregar una.">
				<button type="button" class="btn btn-success" v-on:click.prevent="openModal()">
					<i class="material-icons">note_add</i> Agregar Pregunta
				</button>
			</empty>
		</div>

		<!-- Modal -->
		<div class="modal fade" id="modalEncuestaDetalle" role="dialog" aria-labelledby="modal" aria-hidden="true">
			<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="modal">
							<template v-if="edit">
								Editar Pregunta
							</template>
							<template v-else>
								Agregar Pregunta
							</template>
						</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-md-12 form-group">
								<label>
									Código Pregunta:
								</label>
								<input type="number" name="codigo" class="form-control" placeholder="Código" min="1" v-model="form.codigo" :disabled="edit">
								<errors :errors="form.errors.codigo_pregunta"/>
							</div>

							<div class="col-md-12 form-group">
								<label>
									Pregunta:
								</label>
								<textarea name="pregunta" class="form-control" placeholder="Pregunta" maxlength="100" v-model="form.pregunta"></textarea>
								<errors :errors="form.errors.pregunta"/>
							</div>
							
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal" :disabled="loading">
							Cerrar
						</button>
						<button type="button" class="btn btn-primary" v-on:click.prevent="postDetalle()" :disabled="loading" v-if="!edit">
							Guardar
						</button>
						<button type="button" class="btn btn-primary" v-on:click.prevent="updateDetalle()" :disabled="loading" v-else>
							Actualizar
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default{
		props: ['encuesta'],

		mounted(){
			this.get();
			//this.index();
		},

		data(){
			return {
				form: {
					codigo: '',
					pregunta: '',
					errors: [],
				},
				loading: false,
				edit: false,
				encuestas: [],

				loadingData: false,
			}
		},

		methods: {
			get: function(){
				var url = "/api/encuestasDetalle?encuesta="+this.encuesta;
				this.loadingData = true;
				axios.get(url).then(response => {
		        	this.encuestas = response.data;
	        	}).catch(error=>{
	        		this.$toasted.show('Error al cargar, por favor refresque');
	        		console.log(error.response);
	        	}).then(() => {
	        		this.loadingData = false;
	        	});
			},

			postDetalle: function(){
	        	var url = '/api/encuestasDetalle';
	        	this.loading = true;

	        	axios.post(url, {
	          		codigo_encuesta: this.encuesta,
	          		codigo_pregunta: this.form.codigo,
	          		pregunta: this.form.pregunta
	        	}).then(response => {
		        	this.$toasted.show('Pregunta Agregada');
		        	this.closeModal();
	        	}).catch(error=>{
	        		this.$toasted.show('Error al agregar pregunta');
	        		console.log(error.response);
	        		if (error.response.status == 422){
                    	this.form.errors = _.toArray(error.response.data)[1];
				    }
	        	}).then(()=>{
	        		this.loading = false;
	        		this.get();
	        	});
	      	},

	      	updateDetalle: function(){
	        	var url = '/api/encuestasDetalle/'+this.encuesta;
	        	this.loading = true;

	        	axios.put(url, {
	          		codigo_pregunta: this.form.codigo,
	          		pregunta: this.form.pregunta
	        	}).then(response => {
		        	this.$toasted.show('Pregunta Actualizada');
		        	this.closeModal();
	        	}).catch(error=>{
	        		this.$toasted.show('Error al actualizar pregunta');
	        		console.log(error.response);
	        		if (error.response.status == 422){
                    	let errors = Object.values(error.response.data.errors);
                    	console.log(errors);
                    	errors = errors.flat();
	        			this.form.errors = errors;
				    }
	        	}).then(()=>{
	        		this.get();
	        		this.loading = false;
	        	});
	      	},

	      	editModal: function(data){
	      		this.form.codigo = data.CODIGO_PREGUNTA;
	      		this.form.pregunta = data.PREGUNTA;
	      		this.edit = true;
	      		$('#modalEncuestaDetalle').modal('show');
	      	},

	      	deleteModal: function(data){
	      		var $module = this;
	      		var url = '/api/encuestasDetalle/'+data.CODIGO_ENCUESTA+'/'+data.CODIGO_PREGUNTA;
	        	this.loading = true;

	        	$.confirm({
                    title: '¿Estás seguro?',
                    content: '¡Ya no podrás recuperar esta información!',
                    theme: 'supervan', // 'material', 'bootstrap'
                    buttons: {
                        confirmar: function () {
                            axios.delete(url).then(response => {
					        	$module.$toasted.show('Pregunta Eliminada');
					        	$module.closeModal();
				        	}).catch(error=>{
				        		$module.$toasted.show('Error al eliminar pregunta');
				        		console.log(error.response);
				        		if (typeof error.response.data === 'object') {
			                        $module.form.errors = _.flatten(_.toArray(error.response.data));
			                    } else {
			                        $module.form.errors = ['Algo salió mal. Inténtalo de nuevo.'];
			                    }
				        	}).then(()=>{
				        		$module.get();
				        		$module.loading = false;
				        	});
                        },
                        cancelar: function () {
                        },
                    }
                });
	      	},

	      	openModal: function(){
	      		if(this.encuestas.length>0){
	      			this.form.codigo = this.encuestas[this.encuestas.length-1]['CODIGO_PREGUNTA'] ? this.encuestas[this.encuestas.length-1]['CODIGO_PREGUNTA'] : 1;	
	      		}else{
	      			this.form.codigo = 0;
	      		}
	      		
	      		this.form.codigo++;
	      		this.form.pregunta = '';
	      		this.edit = false;
	      		$('#modalEncuestaDetalle').modal('show');
	      	},

	      	closeModal: function(){
	      		this.form.codigo = 1;
	      		this.form.pregunta = '';
	      		this.edit = false;
	      		$('#modalEncuestaDetalle').modal('hide');
	      	},

	      	index(){
				$(this.$el).children('#encuestas').DataTable({
					"order": [[ 0, "desc" ]],
					"processing": true,
                    "serverSide": false,
                    "language": {
                        "info": "<b>Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros</b>",
                        "search": "Buscar",
                        "lengthMenu": "Mostrar _MENU_ registros",
                        "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                        "paginate": {
                            "next": "Siguiente",
                            "previous": "Anterior",
                        },
                        "lengthMenu": 'Mostrar <select2 >'+
                                    '<option value="10">10</option>'+
                                    '<option value="30">30</option>'+
                                    '<option value="-1">Todos</option>'+
                                    '</select2> registros',
                        "loadingRecords": "Cargando...",
                        "processing": '<i class="fa fa-spinner fa-spin fa-3x fa-fw"></i><span class="sr-only">Loading...</span>',
                        "emptyTable": "No se encontraron resultados",
                        "zeroRecords": "No hay coincidencias", 
                        "infoEmpty": "",
                        "infoFiltered": ""
                    }
                });
			}
	    }
	}
</script>